import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "text-end" }

import SelectField from "../Misc/SelectField.vue";
import {ConfirmModal} from "../Misc/";
import {BButton} from "../BButton";
import {useCommunityPolicingStore} from "@/stores/communityPolicingStore";
import {storeToRefs} from "pinia";
import {ref, watch, computed, onMounted} from "vue";
import {SelectItem} from "@/types";
import {handleError} from "@/stores/storeHelper";
import {useConfirmDialog} from "@/composable/useConfirmDialog";

export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteReport',
  setup(__props) {

const communityPolicingStore = useCommunityPolicingStore();
const {stopNumberOris: agencies} = storeToRefs(communityPolicingStore);
const selectedOri = ref("");
const year = ref(0);
const years = ref([] as SelectItem[]);
const stopNumber = ref("");
const loading = ref<boolean>(false);
const canSubmit = computed(() => {
    return year.value && stopNumber.value && selectedOri.value != null;
});

watch(
    () => selectedOri.value,
    async (val: any) => {
        if (selectedOri.value) {
            years.value = [] as SelectItem[];
            let availableYears = await communityPolicingStore.getGetAvailableStopNumberYears(selectedOri.value);

            years.value = availableYears.map((x) => ({label: `${x}`, value: x} as SelectItem));
            year.value = 0;
        }
    }
);

const {confirm} = useConfirmDialog();

const submit = async () => {
    const shouldProceed = await confirm("Delete Confirmation", "Are you sure you want to delete this stop?");

    if (shouldProceed) {
        communityPolicingStore.validateStopInfo(stopNumber.value, selectedOri.value, year.value).then((result) => {
            if (result && result.data) {
                communityPolicingStore
                    .submitDelete(stopNumber.value, selectedOri.value, year.value)
                    .then((response) => {
                        window.location.href = "dataupload.aspx?source=6";
                    })
                    .catch(function (error) {
                        handleError(error);
                    });
            } else {
                handleError(
                    "The record couldn't be located using the information that was provided. Please verify your information and try the request again."
                );
            }
        });
    }
};
onMounted(async () => {
    await communityPolicingStore.getStopNumberOris();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "agency",
          class: "form-label"
        }, "Agency:", -1)),
        _createVNode(SelectField, {
          id: "agency",
          modelValue: selectedOri.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOri).value = $event)),
          "select-items": _unref(agencies),
          "is-horizontal": false,
          "is-required": true
        }, null, 8, ["modelValue", "select-items"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          for: "year",
          class: "form-label"
        }, "Year:", -1)),
        _createVNode(SelectField, {
          id: "year",
          modelValue: year.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((year).value = $event)),
          "select-items": years.value,
          "is-horizontal": false,
          "is-required": true
        }, null, 8, ["modelValue", "select-items"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "stop-number",
          class: "form-label"
        }, "Stop Number:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stopNumber).value = $event)),
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, stopNumber.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(BButton), {
          type: "submit",
          loading: loading.value,
          disabled: !canSubmit.value
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Submit ")
          ])),
          _: 1,
          __: [6]
        }, 8, ["loading", "disabled"])
      ])
    ], 32),
    _createVNode(_unref(ConfirmModal))
  ], 64))
}
}

})